import type { EntityCtx } from '@cli-types/next-adapter/generators.js'
import { renderSlugHelpersComponentTemplate } from '@next-adapter/templates/renderers/generators/actions/entity-file-contents/generate-slug-helpers.js'

export function generateSlugHelpers(ctx: EntityCtx): string {
  const constraintName = `${ctx.tableName}_slug_key`

  return renderSlugHelpersComponentTemplate({
    stringify: JSON.stringify(constraintName),
    ctxSingular: ctx.Singular,
    ctxTableVar: ctx.tableVar
  })
}
